<script>
import { mapActions, mapState } from 'vuex'
import ArticlesTeaser from '@/components/articles-teaser'

export default {
  name: 'articles',
  components: {
    'articles-teaser': ArticlesTeaser
  },
  data () {
    return {
      articlesList: null
    }
  },
  computed: {
    ...mapState([
      'categoryMap',
      'contentMap'
    ]),
    title () { return this.$route.meta.label },
    category () { return this.$route.meta.category },
    articlesListx () {
      let categoryMap
      categoryMap = Array.from(this.categoryMap[ this.category ])
      if (categoryMap) {
        return categoryMap
      }
      return null
    }
  },
  created () {
    this.fetchAtrticles()
  },
  watch: {
    '$route': 'fetchAtrticles'
  },
  methods: {
    ...mapActions([
      'aFetchContent'
    ]),
    fetchAtrticles () {
      this.aFetchContent(this.category)
        .then(() => {
          this.articlesList = Array.from(this.categoryMap[ this.category ])
        })
    }
  }
}
</script>

<template>
  <el-main>
    <el-row>
      <section class="articles">
      <h1>{{ title }}</h1>
      <articles-teaser
        v-for="articleId in articlesList"
        :key="articleId"
        :article="contentMap[articleId]"
        :category="category"
      ></articles-teaser>
      </section>
    </el-row>
  </el-main>
</template>



// WEBPACK FOOTER //
// src/components/articles.vue